import * as types from './mutation-types'
import {BASE_URL} from "@/services/api";

export const loadPayments = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
      window.axios.get('get/payments/collection', data).then((response) => {
        commit(types.ADD_PAYMENTS, response.data.payments)
        resolve(response)
      }).catch((err) => {
        reject(err)
      })
    })
  }

  export const loadPaymentEnums = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
      window.axios.get('get/payment/methods', data).then((response) => {
        commit(types.ADD_PAYMENT_ENUMS, response.data)
        resolve(response)
      }).catch((err) => {
        reject(err)
      })
    })
  }
export const loadPaymentStatusEnums = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.get('get/payment/status/enum', data).then((response) => {
      commit(types.ADD_PAYMENT_STATUS_ENUMS, response.data)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
  export const updatePayment = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
      window.axios.post('update/payment/' + data.id , data).then((response) => {
        resolve(response)
      }).catch((err) => {
        reject(err)
      })
    })
  }
  
  export const createPayment = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
      window.axios.post('store/payment', data).then((response) => {
        commit(types.ADD_PAYMENT, response.data.payment)
        resolve(response)
      }).catch((err) => {
        reject(err)
      })
    })
  }
  
  export const changePaymentOnlineStatus = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
      window.axios.post('set/payment/online', data).then((response) => {
        resolve(response)
      }).catch((err) => {
        reject(err)
      })
    })
  }

export const deletePayment = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/' + id + '/payment').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const loadSocietyPaymentSettings = ({ commit }, provider) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`payment/${provider}/settings`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const updateSocietyPaymentSettings = ({ commit }, { provider, data }) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`payment/${provider}/settings`, data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
